import React from 'react';

import DasboardHeaderContainer from '../views/sections/components/Header/container';

interface ProviderProps {
    selector: any | null,
    title: string,
    withRating?: boolean,
    withScoreBoard?: boolean,
}
const DasboardHeaderProvider: React.FC<ProviderProps> = ({
    title, 
    selector, 
    withRating=true,
    withScoreBoard=true,
    }) => {

    const childProps = {
        title,
        selector,
        withRating,
        withScoreBoard,
    }

    return (<DasboardHeaderContainer {...childProps} />);
}

export default DasboardHeaderProvider;